/**
 * This removes all "non-printable" ascii characters (the ones that aren't in the ascii range from 0 to 126), so this
 * removes all "extended" ascii characters.
 * @see https://en.wikipedia.org/wiki/List_of_Unicode_characters#Basic_Latin to see which characters are affected.
 */
const removeNonPrintableAsciiCharacters = (input: string): string => input.replace(/[^\x00-\x7F]/g, '');

/**
 * "NFD" normalizes characters so e.g. é becomes e'. The "replace" then removes all accents, so we're left with just an e in this case.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions/Unicode_Property_Escapes
 */
const normalizeString = (input: string): string => input.normalize('NFD').replace(/\p{Diacritic}/gu, '');

export const sanitizeString = (input: string): string => removeNonPrintableAsciiCharacters(normalizeString(input));
